import React from 'react'

function UnableToCompleteRequest(props) {
    const {message}=props;
  return (
    <div>
        <h2 className='request'>Unable to complete your request</h2>
        <p>{message}</p>
    </div>
  )
}

export default UnableToCompleteRequest